import {GenericList} from './GenericList';
import {Employee} from '../../models/Employee';

export class EmployeeList extends GenericList<Employee> {}
